import {BASE_CITY, BASE_CITY_PREPOSITIONAL, BASE_CITY_ID, BASE_CITY_SELECTED_BY_USER, BASE_CITY_PHONE,  CLEAR} from '../constants/BaseCity'

export function setCity(baseCityName) {
  return {
    type: BASE_CITY,
    payload: baseCityName
  }
}

export function setCityPrepositional(baseCityPrepositional) {
  return {
    type: BASE_CITY_PREPOSITIONAL,
    payload: baseCityPrepositional
  }
}

export function setCityID(baseCityID) {
  return {
    type: BASE_CITY_ID,
    payload: baseCityID
  }
}

export function setCityPhone(baseCityPhone) {
  return {
    type: BASE_CITY_PHONE,
    payload: baseCityPhone
  }
}

export function setCitySelected(baseCitySelectedByUser) {
  return {
    type: BASE_CITY_SELECTED_BY_USER,
    payload: baseCitySelectedByUser
  }
}

export function clear() {
  return {
    type: CLEAR
  }
}


// WEBPACK FOOTER //
// ./src/actions/SetCity.js